import { Component, OnInit }                  from '@angular/core';
import { UserService, RolesService,
         StorageService, ToastService, APIService }       from '../_services/index';
import { BrowserModule, Title }               from '@angular/platform-browser';
import { Router }                             from '@angular/router';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {
    public current_user;
    public settings;
    public footer: string = '';

    constructor(public router: Router,private user: UserService, private api: APIService, private roles: RolesService, private storage: StorageService, private toast: ToastService, private titleService: Title) {
        this.current_user = this.storage.getObject('user');
        this.settings = this.storage.getObject('settings');
        if(this.settings == null) {
            this.getData();
        } else {
            this.titleService.setTitle( this.settings[0].value );
            this.footer = this.settings[1].value;
        }
    }

    public disabled:boolean = false;
    public status:{isopen:boolean} = {isopen: false};

    public toggled(open:boolean):void {
        console.log('Dropdown is now: ', open);
    }

    public toggleDropdown($event:MouseEvent):void {
        $event.preventDefault();
        $event.stopPropagation();
        this.hideSidebar();
        this.status.isopen = !this.status.isopen;
    }
    hideSidebar(){
        document.body.classList.remove('mobile-open');
    }
    getData() {
        if(this.current_user.role.name == 'Team'){
            console.log("<<<team found");
            return;
        }
        this.api.getSettings().subscribe(
            data => {
                console.log(data);
                let userData = data.data.settings;
                this.storage.storeObject('settings',userData);
                this.titleService.setTitle( userData[0].value );
                this.footer = userData[1].value;
            },
            error => {
                // this.toast.popToastFail(error.message,'');
            }
        );
    }

    logOut() {
        if(this.current_user.role.name == 'Team'){
            console.log("<<<team found");
            this.storage.removeAll();
            this.hideSidebar();
            this.router.navigate(['users/login']);
            return;
        }
        this.user.logout().subscribe(
            data => {
                let user = data;
                console.log(user.data);
                if (user && user.status == 'failed') {
                    this.toast.popToastFail(user.message, '');
                } else {
                    this.storage.removeAll();
                    this.hideSidebar();
                    this.router.navigate(['users/login']);
                }
            },
            error => {
                this.toast.popToastFail('Error',error);
            }
        );
    }

    ngOnInit(): void {

    }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts